<template>
  <div class="appBody h5-login bg-white">
    <div class="d-flex align-items-center justify-content-center mb-40">
      <router-link tag="img" :to="{path: '/'}"
                   v-if="isShow" src="/static/img/index/logo.png">
      </router-link>
      <p v-else class="mb-0 find-pass-title">重置密码</p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "phoneLoginLayout",
    data() {
      return {
        isShow: true
      }
    },
    mounted() {
      if (this.$route.fullPath.split('/').pop() === 're-register') {
        this.isShow = false;
      }
    }
  }
</script>

<style>
  .w-43 {
    width: 43%;
  }

  .find-pass-title {
    height: 3rem;
    font-size: 1.5rem;
    color: #0d0d0d;
    text-align: center;
  }
</style>
